import React from "react";
import { useQuery } from "react-query";

import { fetchSAVCategories } from 'utils/queries';


import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';


const SAVCategorieSelect = ({ name, value, onChange }) => {

    //const [creation, setCreation] = React.useState(false);


    const {
        isLoading,
        error,
        data,
    } = useQuery(
        ["SAVCategories"],
        fetchSAVCategories
    );

    const handleChange = (categorieIndex) => {

        console.log("handleChange", categorieIndex);

        let categorie = data[categorieIndex];

        console.log("handleChange categorie", categorie);
        onChange({ target: { name: name, value: { ...categorie, index: categorieIndex } } });
    };

    if (isLoading) {
        return (<p>Chargement en cours</p>);
    }

    if (error) {
        return (<p>Erreur du chargement des catégories SAV, veuillez contacter le support.</p>);
    }


    if (!data) {
        return null;
    }

    //console.log("Categories data=", data);

    return (
        <>
            <TextField style={{ paddingBottom: '8px' }}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                    shrink: true
                }}

                label={"Catégorie du produit"}
                required
                select

                name={name}
                value={value.index}
                onChange={e => { handleChange(e.target.value); }}
            >


                {data.map((categorie, index) => {
                    return (
                        <MenuItem key={index} value={index}>
                            {categorie.libelle}
                        </MenuItem>
                    );
                })}



            </TextField>

        </>
    );

}



export default SAVCategorieSelect;